// extracted by mini-css-extract-plugin
export var clauseRow = "_fg-6";
export var emptyState = "_fg-d";
export var filterContent = "_fg-a";
export var filterGroup = "_fg-1";
export var filterGroupContainer = "_fg-0";
export var nestedGroup = "_fg-2";
export var nestedGroupContent = "_fg-b";
export var nestedGroupDepth1 = "_fg-3";
export var nestedGroupDepth2 = "_fg-4";
export var nestedGroupDepth3 = "_fg-5";
export var nestedGroupEmpty = "_fg-c";
export var operatorAnd = "_fg-8";
export var operatorOr = "_fg-9";
export var operatorToggle = "_fg-7";
export var removeGroupButton = "_fg-e";